import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetMoveQuery } from "@/store/moves/apis";
import MoveInvoice from "./MoveInvoice";

const Invoice: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: move } = useGetMoveQuery(id);

  useEffect(() => {
    // Save the original viewport meta tag content
    const originalViewport = document
      .querySelector('meta[name="viewport"]')
      ?.getAttribute("content");

    // Set the new viewport meta tag to prevent zooming
    document
      .querySelector('meta[name="viewport"]')
      ?.setAttribute(
        "content",
        "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      );

    // Restore the original viewport meta tag when component unmounts
    return () => {
      if (originalViewport) {
        document
          .querySelector('meta[name="viewport"]')
          ?.setAttribute("content", originalViewport);
      }
    };
  }, []);

  return (
    <div className="p-4">
      <div className="w-full lg:max-w-2xl lg:p-8">
        <MoveInvoice move={move} buttonsPosition="bottom" />
      </div>
    </div>
  );
};

export default Invoice;
